import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

promotionCodeFormStyles.applyButton = {
    variant: "primary",
    hoverMode: "none",
    css: css`
        padding: 8px 192%;
        margin-top: 8px;
        border-radius: 0rem;
        span[class^="TypographyStyle"] {
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 8px 140% !important;
                    `,
                    css`
                        padding: 8px 140% !important;
                    `,
                    css`
                        padding: 8px 140% !important;
                    `,
                    null,
                ],
                "max",
            )}
    `,
};
promotionCodeFormStyles.form = {
    css: css`
        > div > label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
promotionCodeFormStyles.promotionCodeTextField = {
    css: css``,
};

promotionCodeFormStyles.promotionCodeGridItem = {
    width: 12,
};
promotionCodeFormStyles.applyPromotionGridItem = {
    width: [4, 4, 4, 3, 3],
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
        margin-top: 0 !important;
    `,
};

promotionCodeFormStyles.removeCodeTag = {
    typographyProps: {
        ellipsis: true,
        color: "primary",
        css: css`
            width: 100%;
            text-align: left;
            margin: 5px 0;
        `,
    },
    css: css`
        span[class^="TypographyStyle"] {
            margin-right: 10px;
            margin-bottom: 0;
            margin-top: 7px;
        }
        button {
            background-color: transparent !important;
        }
    `,
};
